<template lang="pug">
AsideModalReceipt(
    :id="id",
    width="w-xxxl",
    :loading="onLoading('fetch-transaction')"
)
    span(slot="header-text") {{ hasTransaction && isVoided && !loading ? 'Voided' : '' }} Receipts
    div.padding.receipt(slot="body")
        div(v-if="hasTransaction && ! loading")
            receipt-details
            receipt-orders
            receipt-amount
            receipt-footer
        div(v-else)
            h1.text-center
                v-loading(loader="fetch-transaction")

    button.btn.btn-fw.white(
        v-if="hasEInvoiceFeature",
        slot="footer-left",
        :disabled="loading",
        @click="viewEInvoice()"
    )
        i.fa.fa-file-text-o(style="margin-right: 5px;")
        | E-Invoice
    button.btn.btn-fw.dark(
        slot="footer-right",
        :disabled="loading",
        @click="print()"
    ) Print
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AsideModalReceipt from '@js/components/AsideModalReceipt.vue';
import Feature from '@js/plugins/feature';
import receiptDetails from './details.vue';
import receiptOrders from './orders.vue';
import receiptAmount from './amount.vue';
import receiptFooter from './footer.vue';

export default {
    components: {
        AsideModalReceipt,
        receiptDetails,
        receiptOrders,
        receiptAmount,
        receiptFooter,
    },
    props: {
        id: {
            type: String,
            default: 'receipt',
        },
    },

    computed: {
        ...mapGetters('transaction', [
            'receipt',
            'hasTransaction',
            'isVoided',
            'transaction',
        ]),

        loading() {
            return this.onLoading('fetch-transaction');
        },

        hasEInvoiceFeature() {
            return (
                Feature.hasFeature('e_invoice') &&
                !!(this.transaction && this.transaction.outlet_einvoice_enabled)
            );
        },

        hasEInvoice() {
            return !!(this.transaction && this.transaction.url_einvoice);
        },
    },

    created() {
        this.registerEvent();
    },

    methods: {
        ...mapActions('transaction', ['getTransaction']),

        print() {
            window.location.href = Laroute.route(
                'franchise.report.transaction.exportReceipt',
                { id: this.receipt.transaction_id },
            );
        },

        viewEInvoice() {
            if (this.transaction && this.transaction.url_einvoice) {
                let url = this.transaction.url_einvoice;

                // Determine base URL based on current environment
                const currentHost = window.location.hostname;
                let baseUrl;

                if (
                    currentHost === 'localhost' ||
                    currentHost === '127.0.0.1'
                ) {
                    // Local environment
                    baseUrl = 'http://localhost:8000';
                } else if (
                    currentHost.includes('slurpstaging') ||
                    currentHost.includes('staging')
                ) {
                    // Staging environment
                    baseUrl = 'https://slurpstaging.getslurp.com';
                } else {
                    // Production environment
                    baseUrl = 'https://cloud.getslurp.com';
                }

                let path = url;
                if (url.includes('/e-inv/')) {
                    path = url.substring(url.indexOf('/e-inv/'));
                } else if (!url.startsWith('/')) {
                    // If URL doesn't have protocol, treat as relative path
                    path = '/' + url;
                }

                // Construct final URL
                const finalUrl = baseUrl + path;

                window.open(finalUrl, '_blank');
            } else {
                alert('E-Invoice URL not available.');
            }
        },

        registerEvent() {
            this.$on('show-receipt', transaction_id => {
                if (this.loading) return;

                this.toggleModal('show');
                this.getTransaction(transaction_id);
            });
        },

        toggleModal(action) {
            $('#receipt').modal(action);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/receipt/receipt.vue